const columnChart = () => {
    return {
        chart: null,

        init() {
            setTimeout(() => {
                this.drawChart(this.$wire)
            }, 0)
        },

        drawChart(component) {
            if (this.chart) {
                this.chart.destroy()
            }

            const months = component.get('months');

            const data = component.get('usage');
            const series = [{
                name: 'SMS-enheter',
                data: data
            }]

            var options = {
                chart: {
                    type: 'bar'
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top'
                        }
                    }
                },
                series: series,
                xaxis:{
                    categories: months
                },
                dataLabels: {
                    offsetY: -20,
                    style: {
                        colors: ['#000000']
                    }
                }
            }


            this.chart = new ApexCharts(this.$refs.container, options);
            this.chart.render();
        }
    }
}

export default columnChart
